import { DataTable, TableProvider } from "@xest-ui/data-table";
import MyPaginator from "components/PaginatedTable/MyPaginator";
import { DefaultTableComponents } from "components/PaginatedTable/DefaultTableComponents";
import { useHistory, useLocation } from "react-router-dom";
import updateQueryParams from "components/PaginatedTable/updateQueryParams";
import React from "react";
import getUsers from "services/getUsers";
import COUNTRY_OPTIONS from "constants/countryOptions";

const statusStyle = {
  color: "#fff",
  backgroundColor: "#28a745",
  borderColor: "#28a745",
  display: "inline-block",
  fontWeight: 400,
  textAlign: "center",
  verticalAlign: "middle",
  border: "1px solid transparent",
  padding: ".375rem .75rem",
  fontSize: "1rem",
  lineHeight: "1.5",
  borderRadius: ".25rem",
};

const getCountryNameById = (id) => {
  const country = COUNTRY_OPTIONS.find((c) => c.value === Number(id));
  return country ? country.label : "N/A";
};

const UsersTable = ({
  usersRefreshKey,
  setShowAdminCreateSubscription,
  setUserRecord,
}) => {
  const history = useHistory();
  const location = useLocation();

  const cols = [
    {
      dataIndex: "user_id",
      title: "User ID",
      filterType: {
        dbCol: "users.user_id",
        type: "string",
      },
    },
    {
      dataIndex: "first_name",
      title: "First Name",
      filterType: {
        dbCol: "users.first_name",
        type: "string",
      },
      ellipsis: {
        showTitle: true,
      },
    },
    {
      dataIndex: "last_name",
      title: "Last Name",
      filterType: {
        dbCol: "users.last_name",
        type: "string",
      },
    },
    {
      dataIndex: "email",
      title: "Email",
      filterType: {
        dbCol: "users.email",
        type: "string",
      },
      ellipsis: {
        showTitle: true,
      },
    },
    {
      dataIndex: "meta",
      title: "Country",
      filterType: {
        dbCol: "users.meta",
        type: "json",
      },
      render: (record) => {
        if (record) {
          return getCountryNameById(record.country);
        }
        return "Unknown Country";
      },
    },
    {
      dataIndex: "phone_number",
      title: "Phone Number",
      filterType: {
        dbCol: "users.phone_number",
        type: "string",
      },
    },
    {
      dataIndex: "organization_name",
      title: "Organization Name",
      filterType: {
        dbCol: "organizations.organization_name",
        type: "string",
      },
    },
    {
      dataIndex: "subscribed_product",
      title: "Subscribed Product",
      filterType: {
        dbCol: "subscribed_product",
        type: "string",
      },
      render: (record) => {
        return record.subscribed_product !== null
          ? record.subscribed_product
          : "N/A";
      },
    },
    {
      dataIndex: "subscriptions.subscription_status",
      title: "Subscription Status",
      filterType: {
        dbCol: "subscription_status",
        type: "string",
      },
      render: (record) => {
        if (record.subscription_status === "active") {
          return <span style={statusStyle}>{record.subscription_status}</span>;
        }
        return record.subscription_status !== null
          ? record.subscription_status
          : "N/A";
      },
    },

    // {
    //   dataIndex: "subscription_type",
    //   title: "Subscription Type",
    //   filterType: {
    //     dbCol: "subscription_type",
    //     type: "string",
    //   },
    //   render: (record) => {
    //     return record !== null ? record : "N/A";
    //   },
    // },
    // {
    //   dataIndex: "source",
    //   title: "Subscription Source",
    //   filterType: {
    //     dbCol: "source",
    //     type: "string",
    //   },
    //   render: (record) => {
    //     return record !== null ? record : "N/A";
    //   },
    // },

    {
      dataIndex: "subscriptions.credits_allocated",
      title: "Credits Allocated",
      filterType: {
        dbCol: "credits_allocated",
        type: "number",
      },
      render: (record) => {
        return record.credits_allocated !== null
          ? record.credits_allocated
          : "N/A";
      },
    },
    {
      dataIndex: "subscriptions.credits_remaining",
      title: "Credits Remaining",
      filterType: {
        dbCol: "credits_remaining",
        type: "number",
      },
      render: (record) => {
        return record.credits_remaining !== null
          ? record.credits_remaining
          : "N/A";
      },
    },
    {
      dataIndex: "subscriptions.subscription_created_at",
      title: "Subscription Created At",
      filterType: {
        dbCol: "subscription_created_at",
        type: "date",
      },
      render: (record) => {
        return record.subscription_created_at !== null
          ? record.subscription_created_at.split(" ")[0]
          : `N/A`;
      },
    },
    {
      dataIndex: "subscriptions.subscription_expiry_date",
      title: "Subscription Expire At",
      filterType: {
        dbCol: "subscription_expiry_date",
        type: "date",
      },
      render: (record) => {
        return record.subscription_expiry_date !== null
          ? record.subscription_expiry_date
          : `N/A`;
      },
    },
    {
      title: "Actions",
      render: (record) => (
        <button
          className="btn btn-lg waves-effect waves-light register-button"
          onClick={() => {
            setUserRecord(record);
            setShowAdminCreateSubscription(true);
          }}
        >
          Create Subscription
        </button>
      ),
    },
  ];

  return (
    <TableProvider
      params={{
        apiCallFn: async function (queryParams) {
          const res = await getUsers({ queryParams });
          return {
            data: res.data,
            total: res.data?.metadata?.total || 0,
          };
        },
        initialPageSize: 10,
        config: {
          tableIdentifier: "get-users-table",
          updateSearchQueryParams(newParams) {
            updateQueryParams({
              history,
              location,
              newParams,
            });
          },
        },
        initialSortCriteria: "-users.created_at",
        deps: [usersRefreshKey],
      }}
      components={DefaultTableComponents}
      columns={cols}
    >
      <DataTable pagination={false} />
      <MyPaginator />
    </TableProvider>
  );
};

export default UsersTable;
